import { render } from "./ChatIconUpload.vue?vue&type=template&id=13e51651"
import script from "./ChatIconUpload.vue?vue&type=script&lang=js"
export * from "./ChatIconUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__